import styled from "styled-components";

export const Container = styled.div`
  padding: 20px;
  min-height: 100vh;
  padding-bottom: 60px;
  background-color: #F5F5F5;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
  border-bottom: 1px solid #EBEBEB;
`;

export const Title = styled.h2`
  font-size: 24px;
  font-weight: bold;
  margin: 0;
`;

export const ProfileSection = styled.div`
  display: flex;
  align-items: center;
  padding: 20px;
  background-color: white;
  border: 2px solid #1FBC70;
  border-radius: 16px;
  margin-bottom: 20px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(31, 188, 112, 0.2);
  }
`;

export const ProfileImage = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: #E5E5E5;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 30px;
  overflow: hidden;
  margin-right: 16px;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const ProfileInfo = styled.div`
  flex: 1;
`;

export const ProfileName = styled.div`
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 6px;
  color: #333;
  text-align: left;
`;

export const ProfileDetail = styled.div`
  font-size: 14px;
  color: #666;
  text-align: left;
`;

export const ProfileArrow = styled.div`
  font-size: 24px;
  color: #333;
  margin-left: 12px;
`;

export const MenuSection = styled.div`
  background-color: white;
  border-radius: 16px;
  padding: 8px 0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

export const MenuItem = styled.div`
  display: flex;
  align-items: center;
  padding: 18px 20px;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #F8F8F8;
  }

  &:not(:last-child) {
    border-bottom: 1px solid #F5F5F5;
  }
`;

export const MenuIcon = styled.div`
  width: 24px;
  height: 24px;
  margin-right: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: #333;
`;

export const MenuText = styled.div`
  font-size: 16px;
  color: #333;
  flex: 1;
  text-align: left;
`;

export const MenuArrow = styled.div`
  font-size: 18px;
  color: #999;
`;

export const LogoutButton = styled.button`
  width: 100%;
  padding: 15px;
  margin-top: 20px;
  background-color: #FF4444;
  color: white;
  border: none;
  border-radius: 10px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;

  &:hover {
    background-color: #CC0000;
  }
`;
